<template>
    <v-fade-transition>
        <v-container
            v-if="show"
            class="pa-0"
            style="max-width: 800px;"
        >
            <div class="intro-top" ref="introTop">
                <v-img
                    :src="images.mg.logo"
                    aspect-ratio="2.700133927"
                    class="mx-3"
                />
                <v-img
                    :src="images.secondary.object"
                    aspect-ratio="1.094480823"
                    class="mx-5"
                />
            </div>
            <!--            <v-img :src="images.top" class="image" />-->
            <div class="bg-contents" :style="{ marginTop }">
                <p class="p1 bold" id="title1">발병 위험 질환을 미리 예측하고 관리할 순 없을까?</p>
                <p class="p1 normal mb-5" id="content1">
                    셀비체크업은 건강보험공단으로 부터 건강검진 결과를 가져와 인공지능으로 분석하여 개인 별 맞춤 건강분석 리포트를 제공합니다.
                </p>
                <v-img :src="images.mg.contents1" />
                <v-card class="pa-1 db-card" flat>
                    <v-card-subtitle
                        class="text-center pb-0 subtitle"
                    >
                        건강안심케어
                    </v-card-subtitle>
                    <v-card-title
                        class="justify-center pt-0 main-title"
                    >
                        MG손해보험 헬스케어
                    </v-card-title>
                    <v-card-actions class="justify-center">
                        <v-btn
                            outlined
                            rounded
                            large
                            color="#00afef"
                            class="px-6"
                            @click="goPremium"
                        >
                            12월 서비스 OPEN
                            <v-icon v-if="false">
                                mdi-download
                            </v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-img :src="images.mg.contents2" />
                <v-img :src="images.mg.contents3" />

                <v-dialog v-model="sampleDialog" max-width="600">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            text
                            block
                            class="p1 bold text-decoration-underline"
                            id="btn-sample"
                        >
                            건강분석 리포트 샘플 보기 >
                        </v-btn>
                    </template>
                    <v-card flat>
                        <v-carousel
                            hide-delimiters
                            hide-delimiter-background
                        >
                            <template v-for="(img, index) in images.sample">
                                <v-carousel-item
                                    :key="index"
                                    :src="img"
                                >
                                </v-carousel-item>
                            </template>
                        </v-carousel>
                    </v-card>
                </v-dialog>
                <div class="event-bg">
                    <div class="content-subtitle">
                        MG 손해보험<br/>가입자를 위한 특별한 혜택
                    </div>
                    <div class="content-title">
                        AI 건강안심케어
                    </div>
                    <v-img
                        :src="images.secondary.coupon"
                        class="mt-6"
                    />
                    <div class="content-text">
                        건강할 땐 건강을 잘 유지할 수 있도록
                        질병 예측을 통해 질환의 조기 발견과 예방관리를 아플 땐 빠른 지원과 관리에 집중된 맞춤 케어를 해당 가입자는 모든 서비스를 받으실 수 있습니다.
                    </div>
                </div>
                <p
                    class="p1"
                    id="content2"
                >
                    해당 가입고객은 <span class="bolder">아래 버튼</span>을 누르고
                    질병 예측과 건강 분석 리포트를 받아보세요.
                </p>
                <div
                    id="btn-service-container"
                >
                    <v-btn
                        large
                        block
                        tile
                        x-large
                        class="p1 bold mt-2"
                        id="btn-service"
                        elevation="0"
                        @click="goPremium"
                    >
                        MG손해보험 건강안심케어<br/>12월 서비스 OPEN
                    </v-btn>
                </div>
                <p
                    class="p1"
                    id="content2"
                >
                    아직 보험을 가입하지 않은 분은 아래 <span class="bolder">[간단히 이용해 보기]</span>를 이용해 보세요.
                </p>
                <div
                    id="btn-service-container"
                    class="pb-10"
                >
                    <v-btn
                        outlined
                        x-large
                        large
                        block
                        class="p1 bold mt-2"
                        @click="goSimple"
                    > 간단히 이용해 보기 </v-btn>
                </div>
            </div>
        </v-container>
    </v-fade-transition>
</template>

<script>
export default {
    name: 'introMG',
    data() {
        return {
            show: false,
            sampleDialog: false,
            images: {
                sample: [
                    require('@/assets/images/sample/sample-report-01@3x.png'),
                    require('@/assets/images/sample/sample-report-02@3x.png'),
                    require('@/assets/images/sample/sample-report-03@3x.png'),
                    require('@/assets/images/sample/sample-report-04@3x.png'),
                    require('@/assets/images/sample/sample-report-05@3x.png'),
                    require('@/assets/images/sample/sample-report-06@3x.png'),
                    require('@/assets/images/sample/sample-report-07@3x.png'),
                    require('@/assets/images/sample/sample-report-08@3x.png'),
                    require('@/assets/images/sample/sample-report-09@3x.png'),
                    require('@/assets/images/sample/sample-report-10@3x.png'),
                    require('@/assets/images/sample/sample-report-11@3x.png'),
                    require('@/assets/images/sample/sample-report-12@3x.png'),
                    require('@/assets/images/sample/sample-report-13@3x.png'),
                    require('@/assets/images/sample/sample-report-14@3x.png'),
                    require('@/assets/images/sample/sample-report-15@3x.png'),
                    require('@/assets/images/sample/sample-report-16@3x.png'),
                    require('@/assets/images/sample/sample-report-17@3x.png')
                ],
                secondary: {
                    bg: require('@/assets/images/intro2/checkup-img-bg@3x.png'),
                    coupon: require('@/assets/images/intro2/checkup-img-coupon@3x.png'),
                    event: require('@/assets/images/intro2/checkup-img-event@3x.png'),
                    group_1: require('@/assets/images/intro2/group-13@3x.png'),
                    group_2: require('@/assets/images/intro2/group-13_2@3x.png'),
                    logo: require('@/assets/images/intro2/logo@3x.png'),
                    logo_2: require('@/assets/images/intro2/logo_2@3x.png'),
                    object: require('@/assets/images/intro2/object@3x.png'),
                },
                mg: {
                    logo: require('@/assets/images/mg/mg@3x.png'),
                    contents1: require('@/assets/images/db-promotion/contents-1@3x.png'),
                    contents2: require('@/assets/images/mg/contents-2@3x.png'),
                    contents3: require('@/assets/images/db-promotion/contents-3@3x.png')
                }
            },
            marginTop: '0px'
        }
    },
    methods: {
        goPremium () {
            //window.open('http://m.chcare.kr/dbins') // deeplink for launching the Selvy Checkup mobile application
        },
        goSimple () {
            this.$router.push('userTerms')
        }
    },
    beforeMount() {
        localStorage.setItem('rootPath', '/introMg')
        this.show = true
    },
    mounted () {
        this.marginTop = `${this.$refs.introTop.clientHeight - 20}px`
    }
}
</script>

<style scoped lang="scss">
.bolder {
    font-weight: bold;
}
.p1 {
    font-family: 'NanumSquare', sans-serif;
    word-break: keep-all;
}

.image {
    min-width: 300px;
    object-fit: contain;
}

.v-btn {
    min-width: 0px;
    min-height: 0px;
}

.bg-contents {
    min-width: 300px;
    border-radius: 20px !important;
    background-color: #ffffff;
    position: relative;
    z-index: 5;
}

#title1 {
    padding-top: 44px;
    padding-left: 33px;
    padding-right: 33px;
    width: 100%;
    text-align: center;
    font-size: 26px;
    line-height: 1.31;
    text-align: center;
    color: #1f1f1f;
    border-radius: 20px;
}

#content1 {
    margin-top: 16px;
    margin-bottom: 23px;
    margin-left: 22px;
    margin-right: 22px;
    font-size: 15px;
    line-height: 1.6;
    letter-spacing: -0.19px;
    text-align: center;
    color: #333333;
}

#btn-sample {
    margin-top: 16px;
    margin-bottom: 49px;
    text-align: center;
    font-size: 18px;
    line-height: 1.33;
    letter-spacing: -0.23px;
    color: #00aeee;
}

#content2 {
    margin-top: 40px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 8px;
    font-size: 15px;
    line-height: 1.47;
    letter-spacing: -0.19px;
    text-align: center;
    color: #333333;
}

.event-bg {
    background-image: url("~@/assets/images/db-promotion/img-event-bg@3x.png");
    background-size: cover;
    padding: 47px 60px;

    .content-subtitle {
        color: #b1fffc;
        font-family: NanumSquare, sans-serif;
        font-size: 15px;
        line-height: 20px;
        text-align: center;
        margin-bottom: 15px;
    }

    .content-title {
        color: white;
        font-size: 26px;
        text-align: center;
        font-family: NanumSquare, sans-serif;
        line-height: 34px;
    }

    .content-text {
        font-family: NanumSquare, sans-serif;
        font-size: 15px;
        text-align: center;
        line-height: 22px;
        letter-spacing: -0.19px;
        color: white;
        word-break: keep-all;
        margin-top: 25px;
    }
}

#btn-service-container {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 10px;
}

#btn-service {
    background-color: #00afef;
    color: #ffffff;
    font-size: 16px;
}
#simple-btn-service {
    font-size: 16px;
}

.intro-top {
    position: fixed;
    z-index: 0;
    width: 100%;
    padding: 80px 23px;
    background-image: url("~@/assets/images/intro2/checkup-img-bg@3x.png");
    background-size: cover;

    &-title {
        position: relative;
        width: 292px;
        height: 46px;
        margin-left: auto;
        margin-right: auto;
        padding-top: 70px;
    }

    &-subtitle {
        margin-top: 7px;
        font-family: 'NanumSquare', sans-serif;
        font-size: 16px;
        font-weight: 300;
        line-height: 1.63;
        letter-spacing: -0.32px;
        color: #c3efff;
        text-align: center;
        padding-top: 50px;
    }
}

.event {
    background-image: url("~@/assets/images/intro2/checkup-img-event@3x.png");
    background-size: 100% 410px;
    width: 100%;
    height: 410px;
    word-break: keep-all;

    &-title {
        font-family: 'NanumSquare', sans-serif;
        font-size: 24px;
        line-height: 1.31;
        color: #fff;
        text-align: center;
        padding: 40px 40px 20px 40px;
        word-break: keep-all;
    }

    &-img {
        width: 254px;
        height: 134px;
        padding-top: 17px;
        margin: auto;
    }

    &-subtitle {
        font-size: 16px;
        line-height: 1.47;
        letter-spacing: -0.19px;
        text-align: center;
        padding: 40px 40px;
        color: #fff;
    }
}

.db-card {
    .subtitle {
        font-family: 'NanumSquare', sans-serif;
        font-size: 15px;
        line-height: 24px;
        letter-spacing: -0.19px;
        color: #636363;
    }

    .main-title {
        font-family: 'NanumSquare', sans-serif;
        font-size: 26px;
        line-height: 32px;
        letter-spacing: -0.33px;
        color: #1f1f1f;

    }
}
</style>
